import React from "react";
import BrandWhite from "../assets/72.svg";
import { Link } from "react-router-dom";
import { useModal } from "../context/ModalContext";

const Footer = () => {
  const { openModal } = useModal();
  return (
    <>
      <div className="cta-section">
        <div className="container">
          <div className="cta-content">
            <div className="cta-caption">
              <h2>
                <i>Join us</i> in making roads safer.
              </h2>
            </div>
            <div className="cta-button">
              <button onClick={openModal}>
                Get in touch <i className="fa-solid fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-main-section">
        <div className="container w-100">
          <div className="row w-100">
            <div className="col col-12 col-md-7">
              <div className="row">
                <div className="col col-12 col-md-4 mb-4">
                  <div className="brand mb-5">
                    {/* <h1>shoora</h1> */}
                    <img src={BrandWhite} alt="Shoora" width={130} />
                  </div>
                  <div className="footer-social-container">
                    <ul className="footer-social-group">
                      <li className="footer-social-item">
                        <Link
                          to="https://www.facebook.com/profile.php?id=61566543857192"
                          target="_blank"
                        >
                          <i className="fa-brands fa-square-facebook"></i>
                        </Link>
                      </li>
                      <li className="footer-social-item">
                        <Link
                          to="https://x.com/techshoora?s=11"
                          target="_blank"
                        >
                          <i className="fa-brands fa-square-x-twitter"></i>
                        </Link>
                      </li>
                      <li className="footer-social-item">
                        <Link
                          to="https://www.linkedin.com/company/shooratechnologies/"
                          target="_blank"
                        >
                          <i className="fa-brands fa-linkedin"></i>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col col-12 col-md-8">
                  <div className="footer-links-container">
                    <h5 className=" mb-4">NEWSROOM</h5>
                    <p className=" mb-4 w-75 lh-1">
                      Get the latest news and updates about Shoora.{" "}
                    </p>
                    <Link className="footer-btn" to="/newsroom">
                      Visit the newsroom{" "}
                      <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </div>
                </div>
                <div className="col col-3"></div>
              </div>
            </div>
            <div className="col col-12 col-md-5">
              <div className="row">
                <div className="col">
                  <div className="footer-links-container">
                    <h5>OUR LOCATIONS</h5>
                    <ul className="footer-links-group">
                      <li className="footer-link-item">
                        <Link to="/contact">India</Link>
                      </li>
                      <li className="footer-link-item">
                        <Link to="/contact">Dubai</Link>
                      </li>
                      <li className="footer-link-item">
                        <Link to="/contact">Tanzania </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col">
                  <div className="footer-links-container">
                    <h5>Useful Links</h5>
                    <ul className="footer-links-group">
                      <li className="footer-link-item">
                        <Link to="/about">About Shoora</Link>
                      </li>
                      <li className="footer-link-item">
                        <Link to="/solutions">Solutions</Link>
                      </li>
                      <li className="footer-link-item">
                        <Link to="/insights">Insights</Link>
                      </li>
                      <li className="footer-link-item">
                        <Link to="/contact">Contact us</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-info-section">
        <div className="container">
          <div className="footer-info-container d-flex justify-content-between">
            <Link className="copyright">2024 SHOORA. ALL RIGHTS RESERVED</Link>
            <Link to="/legal/privacy-policy">Privacy Policy</Link>
            <Link to="/legal/terms-of-use">Terms of Use</Link>
            {/* <Link >Cookie Settings</Link> */}
            <Link to="/legal/accessibility-statement">
              Accessibility Statement
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
